import { Flex, Pane, TableV2, Text } from '@leverege/ui-elements'
import useBondedTable from '../hooks/useBondedTable'
import S from './BondedTable.css'

function BondedTable( { fgJob, dispatch, delegate } ) {

  const { data, columns } = useBondedTable( fgJob, dispatch, delegate )

  return (
    <Pane variant="factoryDashboardCardCustom" layout="flex:col" style={{ flex : 1, minWidth : 635 }}>
      <Pane
        variant="factoryDashboardCardCustomBigHeader">
        <Flex variant="rowSpaceBetween">
          <Text variant="tableHeader">Bonded Blade</Text>
        </Flex>
      </Pane>
      <div
        style={{
          height : '100%',
          backgroundColor : '#F3F5F6',
        }}>
        <TableV2
          variant="factoryShellsTable"
          className={S.table}
          data={data}
          columns={columns}/>
      </div>
    </Pane>
  )
}

export default BondedTable
